import { stringify } from 'qs';

import { ISearchTransactionsParams } from '@Shared/interfaces/Filters';

import { Api as apiService } from '../api';

export interface IAggregationCounts {
  [key: string]: number;
}

export interface IAggregationCountsResponse {
  redux: {
    [key: string]: IAggregationCounts;
  };
}

export abstract class AggregationCountsApi {
  static aggregationCountsURL: string = '/api/web/transactions/aggregation';

  static loadAggregationCounts(match: string, params: ISearchTransactionsParams) {
    const query = stringify(params);
    return apiService
      .get(AggregationCountsApi.aggregationCountsURL + `/${match}/count?${query}`)
      .then((response) => response.json() as Promise<IAggregationCountsResponse>);
  }
}
